<app-clients-list-search (changed)="getClientsSearch($event)"></app-clients-list-search>

<div class="table-responsive" style="margin-bottom: 20px">
  <table class="table table-bordered table-hover">
    <thead>
    <tr>
      <th></th>
      <th>Клиент</th>
      <th>Телефон</th>
      <th>Цена</th>
      <th>Комнат</th>
      <th>Местоположение</th>
      <th>Примечание</th>
      <th *ngIf="user.access===4">Агентство</th>
      <th *ngIf="user.access!==4">Сотрудник</th>
      <th *ngIf="access.clients_created">
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field ==='created_at' && (sort.value==='ASC' || sort.value==='DESC')"
             (click)="changeSort('created_at', 'DESC')">
          <i class="fas fa-sort icon-color"></i>Дата доб.
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='created_at' || (sort.field==='created_at' && sort.value==='ASC')"
             (click)="changeSort('created_at', 'ASC')">
          <i class="fas fa-sort-down icon-color"></i>Дата доб.
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='created_at' || (sort.field==='created_at' && sort.value==='DESC')"
             (click)="changeSort('created_at', 'DESC')">
          <i class="fas fa-sort-up icon-color"></i>Дата доб.
        </div>
      </th>
      <th>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field ==='updated_at' && (sort.value==='ASC' || sort.value==='DESC')"
             (click)="changeSort('updated_at', 'DESC')">
          <i class="fas fa-sort icon-color"></i>Дата обн.
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='updated_at' || (sort.field==='updated_at' && sort.value==='ASC')"
             (click)="changeSort('updated_at', 'ASC')">
          <i class="fas fa-sort-down icon-color"></i>Дата обн.
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='updated_at' || (sort.field==='updated_at' && sort.value==='DESC')"
             (click)="changeSort('updated_at', 'DESC')">
          <i class="fas fa-sort-up icon-color"></i>Дата обн.
        </div>
      </th>
      <th>Действия</th>
    </tr>
    </thead>
    <tbody>
    <ng-container
      *ngFor="let client of clients | paginate: { itemsPerPage: limit, currentPage: page, totalItems: countClients }; let i  = index">
      <tr>
        <td class="text-center">
          <a *ngIf="client.access_edit" routerLink="client/{{client.id}}" target="_self">
            <i class="fas fa-pencil-alt icon-color"></i>
          </a>
        </td>
        <td>{{client.surname}} {{client.name}} {{client.patronymic}}</td>
        <td>
          <span *ngIf="client.access_own_info"
                [innerHTML]="client.phone1===null ? '' : client.phone1 | sanitizeHtml"></span><br/>
          <span *ngIf="client.access_own_info"
                [innerHTML]="client.phone2===null ? '' : client.phone2 | sanitizeHtml"></span>
        </td>
        <td>{{client.price}}</td>
        <td>{{client.room_from}}-{{client.room_to}}</td>
        <td>{{client.city.title}}
          <ng-container *ngIf="client.districts.length >0 ">:
            <ng-container *ngFor="let district of client.districts">
              {{district.small_title}},
            </ng-container>
          </ng-container>
        </td>
        <td>{{client.description }}</td>
        <td *ngIf="user.access===4">{{client.company.title}}</td>
        <td *ngIf="user.access!==4">{{client.user.user_information.surname}} {{client.user.user_information.name}}</td>
        <td>
          {{client.created_at | date: 'dd.MM.yyyy'}}
        </td>
        <td>
            {{client.updated_at | date: 'dd.MM.yyyy'}}
        </td>
        <td>
          <i class="fas fa-chevron-circle-right icon-color icon-cursor" style="font-size: 20px;"
             (click)="close_hideme(i);"></i>
          <div class="action-window" [hidden]="!hideme[i]">
            <div class="action">ПОДБОР ОБЪЕКТА</div>
            <div *ngIf="client.access_delete" class="action" (click)="openDialog(client)">УДАЛЕНИЕ ПОКУПАТЕЛЯ</div>
          </div>
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</div>


<div class="row no-gutters">
  <!--Пагинация -->
  <div class="col-12 text-center">
    <pagination-controls (pageChange)="getClientsByPage($event)" maxSize="7" previousLabel="" nextLabel=""
                         directionLinks="true" autohide="true"></pagination-controls>
  </div>
  <!-- <div class="col-3 text-right">
     Всего объектов в МЛС: {{countSales}}
   </div>-->
</div>
